import { Col } from 'antd';
import OptionTypeSingleField from './OptionTypeSingleField';

const OptionTypeSingleSelectField = ({ prefix, disabled = false }: { prefix: string; disabled?: boolean }) => (
    <Col lg={24} xs={24}>
        <OptionTypeSingleField disabled={disabled} name={`${prefix}.options`} />
    </Col>
);

export default OptionTypeSingleSelectField;
